import axios from 'axios';
import HttpService from '../http-service/http-service';
import { API_PATH, getApiBaseUrl } from '../../api-paths';

export interface PrinterSettingsResponse {
    boxLabelPrinterName: string;
    palletLabelPrinterName: string;
}

export interface JspmConfiguration {
    reclaimCenterId: string;
    keyVersion: string;
}

export default class PrinterService {
    public async getPrinterSettings(
        reclaimCenterId: string,
        scanCode: string
    ): Promise<PrinterSettingsResponse> {
        const url =
            getApiBaseUrl() +
            API_PATH.PRINTER_SETTINGS +
            reclaimCenterId +
            '/' +
            scanCode;
        return HttpService.get<PrinterSettingsResponse>(url).then(
            (response) => {
                return response.data;
            }
        );
    }

    public getJspmConfigurations(): Promise<JspmConfiguration[]> {
        const url =
            getApiBaseUrl() + API_PATH.PRINTER_SETTINGS_JSPM_CONFIGURATIONS;
        return axios.get(url).then((response) => {
            const list = Array.isArray(response.data) ? response.data : [];
            return list
                .filter(
                    (item) =>
                        item?.isActive !== false &&
                        item?.reclaimCentreId !== null &&
                        item?.reclaimCentreId !== undefined
                )
                .map((item) => ({
                    reclaimCenterId: String(item.reclaimCentreId).trim(),
                    keyVersion: String(item?.keyVersion ?? '').trim(),
                }));
        });
    }
}
